var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5827 1.19694L8.17547 6.86144C7.66252 7.37952 6.87189 7.37952 6.38015 6.86144L0.972964 1.19694C0.460013 0.660571 0.716488 0.25 1.50712 0.25H13.0485C13.861 0.25 14.0956 0.661143 13.5827 1.19694Z",
    fill: "#252C58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownCustom);
export default __webpack_public_path__ + "static/media/dropdown_custom.6475718503d1aa1b232d6a07e7659584.svg";
export { ForwardRef as ReactComponent };